import { Link, useSearchParams } from 'react-router-dom';

export default function LoginSent() {
  const [params] = useSearchParams();
  const email = params.get('email') ?? '';

  return (
    <div className="max-w-md mx-auto mt-16 bg-white rounded-lg shadow p-6">
      <h1 className="text-2xl font-bold mb-4 text-navy">Kolla din mejl</h1>
      <p className="mb-2">
        Vi har skickat en inloggningslänk till{' '}
        <strong>{email || 'din e-post'}</strong>.
      </p>
      <p className="mb-4 text-sm text-gray-600">
        Hittar du inte mejlet? Kolla skräpposten eller{' '}
        <Link to="/login" className="text-sky underline">
          försök igen
        </Link>
        .
      </p>
    </div>
  );
}
